import { render, staticRenderFns } from "./ContainerSimbols.vue?vue&type=template&id=513ecfc4&scoped=true"
import script from "./ContainerSimbols.vue?vue&type=script&lang=js"
export * from "./ContainerSimbols.vue?vue&type=script&lang=js"
import style0 from "./ContainerSimbols.vue?vue&type=style&index=0&id=513ecfc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513ecfc4",
  null
  
)

export default component.exports